<template>
  <div class="app-wrapper">
    <div class="main-container">
      <NavbarDemo v-if="this.tenantSet.tenantNav == 1"/>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { NavbarDemo } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import request from '@/utils/request'

export default {
  data(){
    return{
      us:{},
      tenantSet:{},
    }
  },
  name: 'LayoutDemo',
  components: {
      NavbarDemo
  },
  mixins: [ResizeMixin],
  inject:['reload'],
  computed: {
  },
  created(){
    this.getinfo();
  },
  watch: {
      $route(to, from) {
        if(to.path == '/'){
            this.$confirm('抱歉，账号异常，已为您退出该账号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.$store.dispatch('LogOutT').then(() => {
                  this.reload() // 为了重新实例化vue-router对象 避免bug
                  this.$router.push({path:'/demonstration'});
                })
            }).catch(() => {
                this.$store.dispatch('LogOutT').then(() => {
                  this.reload() // 为了重新实例化vue-router对象 避免bug
                  this.$router.push({path:'/demonstration'});
                })
            });
        }
      }
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.tenantSet = res.tenant
      })
    },
    getCookie(Name) { //cookie
      var search = Name + "=";
      var returnValue = "";
      if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search);
        if (offset !== -1) {
          offset += search.length;
          var end = document.cookie.indexOf(";", offset);
          if (end == -1){
            end = document.cookie.length;
          }
          returnValue = decodeURIComponent(document.cookie.substring(offset, end));
        }
      }
      return returnValue;
    },
    // open() {
    //   if (this.getCookie('set') == ''){ //cookie 中没有 set 则赋给他一个值（此时弹框显示）
    //       document.cookie = "set = yes";
    //       this.$confirm('您还未设置偏好哦！是否前往设置', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning',
    //         customClass: 'messageBox-prompt-test',
    //       }).then(() => {
    //           this.$router.push({path:'/personal'})
    //       })
    //   }
    // },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    width: 100%;
  }
  .app-main{
    background: #f5f5f5;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/LayoutDemo.vue